import axios from 'axios';
import { toast } from 'react-toastify';
import { loadingAction } from '../redux/actions/loadingAction';
// import handleRefreshToken from './RefreshToken.js';
import baseURL from '../Config.js';
import { trimData } from '../utilities/TrimPayloadData.js';

export const handlePostRequest =
    (data, url, isShowLoad = false, isShowToast = true, suppressErrorToast = false) =>
    async (dispatch) => {
        if (!(data instanceof FormData)) {
            data = await trimData(data);
        }
        try {
            const loginData = JSON.parse(localStorage.getItem('adminUser') || localStorage.getItem('userDetails') || '{}');
            const accessToken = loginData?.data?.token || loginData?.data?.accessToken;
            if (isShowLoad) dispatch(loadingAction(true));
            const response = await axios({
                method: 'POST',
                url: `${baseURL + url}`,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${accessToken}`
                }
            });
            if (isShowToast) toast.success(response?.data?.message, { autoClose: 1000 });
            if (isShowLoad) dispatch(loadingAction(false));
            return response;
        } catch (error) {
            // if (error?.response?.status === 401) {
            //     const newToken = await handleRefreshToken();
            //     if (newToken) {
            //         return await handlePostRequest(data, url, isShowLoad, true)(dispatch);
            //     } else {
            //         localStorage.clear();
            //         window.location.href = '/';
            //         toast.error('Session expired. Please log in again.');
            //         return;
            //     }
            // }
            if (isShowLoad) dispatch(loadingAction(false));
            if (axios.isCancel(error)) return;
            if (error?.response?.status === 413) {
                toast.warn('Upload limit reached. Please upload up to 10 photos, 500 KB each.');
                return;
            }
            const payloadHasImages =
                data &&
                typeof data === 'object' &&
                ((Array.isArray(data.photoUrls) && data.photoUrls.length > 0) ||
                    (typeof data.photoUrl === 'string' && data.photoUrl.startsWith('data:image')));
            if (!error?.response && payloadHasImages) {
                toast.warn('Upload failed before reaching server. This is usually a server file-size limit. Try fewer photos or smaller images.');
                return { status: 599, isNetworkError: true, error };
            }
            if (suppressErrorToast) {
                return error?.response || { status: 599, isNetworkError: true, error };
            }
            if (error?.response?.status === 400 || error?.response?.status === 500) {
                toast.warn(error?.response?.data?.messages || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!');
            } else {
                toast.warn(error?.response?.data?.messages || error?.response?.data?.message || error?.response?.data?.error || 'Something went wrong !!');
            }
            if (!error?.response) {
                return { status: 599, isNetworkError: true, error };
            }
            return error.response;
        }
    };
